const initialState = {
  isLoaderVisible: true,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case 'SETTING_LOADER_STATE': {
      return {
        ...state,
        isLoaderVisible: action.data,
      }
    }
    default:
      return state;
  }
}